/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {useLocation} from 'react-router'
import {FC} from 'react'
import {CustomerDetail} from './CustomerDetail'
import {BookingDetail} from './BookingDetail'
import {PaymentDetail} from './PaymentDetail'
import { TravellerInfo } from './TravellerInfo'
import { Tr } from '../../../_metronic/i18n/Tr'

const EditTourBookingDetails: FC = () => {
        let t = Tr()
  
  const location = useLocation()
  const bookingId = (location.state as any)?.bookingId || ''
  const bookingdetailId = (location.state as any)?.bookingdetailId || ''

  useEffect(() => {
    setStatus(0)
  }, [])
  const [status, setStatus] = useState<any>()

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body'>
          <div className='d-flex overflow-auto'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder my-2 flex-nowrap'>
              <li className='nav-item'>
                <button
                  className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                    status == 0 ? 'bg-success text-white rounded' : ''
                  }`}
                  onClick={() => {
                    setStatus('0')
                  }}
                >
                  {t("Customer Details")}
                </button>
              </li>
              <li className='nav-item'>
                <button
                  className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                    status == 1 ? 'bg-success text-white rounded' : ''
                  }`}
                  onClick={() => {
                    setStatus('1')
                  }}
                >
                  {t("Booking Details")}
                </button>
              </li>
              {/* <li className='nav-item'>
                <button
                  className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                    status == 2 ? 'bg-success text-white rounded' : ''
                  }`}
                  onClick={() => {
                    setStatus('2')
                  }}
                >
                  Payment Details
                </button>
              </li> */}
              <li className='nav-item'>
                <button
                  className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                    status == 3 ? 'bg-success text-white rounded' : ''
                  }`}
                  onClick={() => {
                    setStatus('3')
                  }}
                >
                  {t("Traveller Info")}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {status == 0 ? (
        <CustomerDetail bookingId={bookingId} bookingdetailId={bookingdetailId} />
      ) : status == 1 ? (
        <BookingDetail bookingId={bookingId} bookingdetailId={bookingdetailId} />
      ) : status == 2 ? (
        <PaymentDetail bookingId={bookingId} bookingdetailId={bookingdetailId} />
      ) : status == 3 ? (
        <TravellerInfo bookingId={bookingId} bookingdetailId={bookingdetailId} />
      ) : (
        ''
      )}
    </>
  )
}

export {EditTourBookingDetails}
